import posthog from 'posthog-js'

interface UserInfo {
  id: string
  email?: string
  name?: string
}

/**
 * Identify user in PostHog
 */
export function identifyPostHogUser(user: UserInfo) {
  const analyticsEnabled = import.meta.env.VITE_ENABLE_ANALYTICS === 'true'

  if (!analyticsEnabled || !user.id || !posthog.__loaded) {
    return
  }

  try {
    posthog.identify(user.id, {
      email: user.email,
      name: user.name,
    })
  } catch (error) {
    console.error('Failed to identify user in PostHog:', error)
  }
}

/**
 * Track a custom event in PostHog
 */
export function trackEvent(
  eventName: string,
  properties?: Record<string, unknown>
) {
  const analyticsEnabled = import.meta.env.VITE_ENABLE_ANALYTICS === 'true'

  if (!analyticsEnabled || !posthog.__loaded) {
    return
  }

  try {
    posthog.capture(eventName, properties)
  } catch (error) {
    console.error('Failed to track event in PostHog:', error)
  }
}

/**
 * Reset PostHog user (call on logout)
 */
export function resetPostHog() {
  if (!posthog.__loaded) {
    return
  }

  try {
    posthog.reset()
  } catch (error) {
    console.error('Failed to reset PostHog:', error)
  }
}

/**
 * Check if PostHog is enabled and loaded
 */
export function isPostHogReady(): boolean {
  return import.meta.env.VITE_ENABLE_ANALYTICS === 'true' && posthog.__loaded
}

export { posthog }
